// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"31aec784","239":"fe2309b3","455":"db0869b6"}[chunkId] + ".chunk.js";
};